import React from 'react';
import './index.scss';

/**
 * PlayerWrapper component
 * Wraps content and adds appropriate padding when a player is shown
 * 
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Child components to render
 * @param {boolean} props.showPlayer - Whether the player is showing or not
 * @returns {React.ReactElement} The wrapped content with appropriate spacing
 */
const PlayerWrapper = ({ children, showPlayer = true }) => {
  return (
    <div className={showPlayer ? 'content-with-player' : ''}>
      {children}
    </div>
  );
};

export default PlayerWrapper; 